import BaseAPI from '@/apis/base/baseApi';
export default class FixedAssetAPI extends BaseAPI {
  apiName = 'FA';
}
